module.exports = __webpack_public_path__ + "img/9788960516144.ec661c87.jpg";